// extracted by mini-css-extract-plugin
export default {"container":"iP-z","title":"jP-z","link":"kP-z"};